// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConditionInput
 */
export interface ConditionInput {
  /**
   *
   * @type {string}
   * @memberof ConditionInput
   */
  lastTransitionTime?: string;
  /**
   *
   * @type {string}
   * @memberof ConditionInput
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof ConditionInput
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof ConditionInput
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ConditionInput
   */
  type?: string;
}

/**
 * Check if a given object implements the ConditionInput interface.
 */
export function instanceOfConditionInput(
  value: object,
): value is ConditionInput {
  return true;
}

export function ConditionInputFromJSON(json: any): ConditionInput {
  return ConditionInputFromJSONTyped(json, false);
}

export function ConditionInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConditionInput {
  if (json == null) {
    return json;
  }
  return {
    lastTransitionTime:
      json['lastTransitionTime'] == null
        ? undefined
        : json['lastTransitionTime'],
    message: json['message'] == null ? undefined : json['message'],
    reason: json['reason'] == null ? undefined : json['reason'],
    status: json['status'] == null ? undefined : json['status'],
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function ConditionInputToJSON(json: any): ConditionInput {
  return ConditionInputToJSONTyped(json, false);
}

export function ConditionInputToJSONTyped(
  value?: ConditionInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lastTransitionTime: value['lastTransitionTime'],
    message: value['message'],
    reason: value['reason'],
    status: value['status'],
    type: value['type'],
  };
}
